// extracted by mini-css-extract-plugin
export default {"videoList":"VideoList_videoList__wgk1A"};